module.exports = __webpack_public_path__ + "56ced497b4e028570ebf8672d4248659.woff";